import { ChangeDetectorRef, Component, ElementRef, HostBinding, HostListener, ViewChild } from '@angular/core';
import { Column, IHeaderParams } from '@ag-grid-community/core';
import { CommonModule } from '@angular/common';
import { IHeaderAngularComp } from '@ag-grid-community/angular';
import {IconSvgComponent} from '../../icon/icon.component';

/**
 * @deprecated use import { RoomexAgGridHeaderComponent } from '@rx-applications/shared/ui';
 * @link https://www.ag-grid.com/javascript-grid-header-rendering/
 */
@Component({
  standalone: true,
  imports: [CommonModule, IconSvgComponent],
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'rx-custom-ag-header',
  templateUrl: './custom-ag-header.html',
  styleUrls: ['./custom-ag-header.scss'],
})
export class CustomAgGridHeaderComponent implements IHeaderAngularComp {
  public params: IHeaderParams;
  public filterActive = false;
  public filterVisible = false;
  public sortable = false;

  constructor(private cd: ChangeDetectorRef) {}

  @HostBinding('attr.data-qa') dataQa: string;

  @ViewChild('filterButton', { read: ElementRef })
  public filterButton: ElementRef;

  @HostListener('click') onMouseClick() {
    if (this.sortable) {
      this.changedSorting();
    }
  }

  agInit(params: IHeaderParams): void {
    this.params = params;
    this.dataQa = this.params.column.getColDef().headerComponentParams?.testId;
    this.sortable = this.params.column.getColDef().sortable;
    this.params.column.addEventListener(Column.EVENT_MENU_VISIBLE_CHANGED, this.setFilterActive.bind(this));
    this.params.column.addEventListener(Column.EVENT_FILTER_ACTIVE_CHANGED, this.setFilterActive.bind(this));
    this.setFilterActive(this.params);
  }

  onFilterButtonClicked($event: MouseEvent): void {
    $event.stopPropagation();
    this.params.showColumnMenu(this.filterButton.nativeElement);
  }

  changedSorting(): void {
    const sort = this.params.column.getSort();
    if (!sort) {
      this.params.setSort('desc');
    } else if (sort === 'desc') {
      this.params.setSort('asc');
    } else if (sort === 'asc') {
      this.params.setSort(null);
    }
  }

  setFilterActive({ column }: IHeaderParams) {
    this.filterActive = column.isFilterActive() || column.isMenuVisible();
    this.cd.markForCheck();
  }

  get sortIcon(): string {
    const sort = this.params.column.getSort();
    if (!sort || !this.sortable) {
      return '';
    }
    return `ag-icon-${sort}`;
  }

  refresh(params: IHeaderParams): boolean {
    this.params = params;
    return true;
  }
}
